import { MOBILE_MEDIA, TABLET_MEDIA } from '@common/constants/MEDIAS';
import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

export const policyWrapper = css`
  width: 100%;
  margin: 0 auto;
  max-width: 750px;
  color: ${palette.gray14};
  font-weight: normal;
  line-height: 20px;
  list-style: none;
  letter-spacing: -0.3px;
  background-color: white;
  @media screen and (min-width: 1024px) {
    padding: 20px 20px 20px 20px;
  }
  ${TABLET_MEDIA} {
    padding: 64px 20px 20px 20px;
  }
  ${MOBILE_MEDIA} {
    padding: 64px 20px 20px 20px;
  }
  .bg_white {
    background-color: #fff !important;
  }
  .c_gray {
    color: #979797;
  }
  .limit_wrap {
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }
  strong {
    font-weight: 700;
    font-style: normal;
  }
  .align_r {
    text-align: right;
  }
  .Cc5c5c5 {
    color: #c5c5c5 !important;
  }
  .mb12 {
    margin-bottom: 12px;
  }
  .f11 {
    font-size: 11px !important;
  }
  .f13 {
    font-size: 13px;
  }
  .f12 {
    font-size: 12px;
  }
  .f16 {
    font-size: 16px;
  }
  .f18 {
    font-size: 18px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .mb12 {
    margin-bottom: 12px !important;
  }
  .mt5 {
    margin-top: 5px !important;
  }
  .mt20 {
    margin-top: 20px !important;
  }
  .mt10 {
    margin-top: 10px !important;
  }
  .alignSectionStyle {
    padding: 20px;
  }
  .relative {
    position: relative;
  }
  .pd_l10 {
    padding-left: 10px;
  }
  .pd_l20 {
    padding-left: 20px;
  }
  .list_desc {
    li {
      position: relative;
    }

    .desc {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  h1 {
    max-width: 100%;
    font-size: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 56px;
    margin: 0 auto;
  }

  h2 {
    font-size: 16px;
    font-weight: 700;
    color: ${palette.gray14};
    margin-bottom: 10px;
  }

  h3 {
    font-weight: 600;
    margin-bottom: 10px;
    color: ${palette.gray14};
  }
  .termsToggleBtn {
    width: 30px;
    transition: transform 0.5s ease;
  }

  .text {
    font-size: 1rem;
    color: #333;
    word-break: keep-all;
  }

  .scrollBox {
    > div {
      height: 100px;
      padding: 10px;
      background: #f1f1f1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
  .termsCont {
    .termsTable {
      width: 100%;
      border: 1px #ddd solid;
      border-collapse: collapse;

      td,
      th {
        padding: 5px;
        border: 1px #ddd solid;
        font-size: 12px;
        vertical-align: top;
      }

      th {
        text-align: center;
      }

      .w20 {
        width: 20%;
      }
      .w25 {
        width: 25%;
      }
      .w30 {
        width: 30%;
      }
      .w35 {
        width: 35%;
      }
      .w40 {
        width: 40%;
      }
      .w60 {
        width: 60%;
      }
      .w70 {
        width: 70%;
      }
    }

    ul {
      padding-left: 15px;

      li {
        position: relative;
        line-height: 20px;
        vertical-align: middle;
      }
    }
  }

  .dealerList {
    background-color: #fff;
    height: 50vh;
    overflow: hidden;
    overflow-y: scroll;
    .dealerTable {
      width: 100%;
      border: 1px #ddd solid;
      border-collapse: collapse;

      td,
      th {
        padding: 5px;
        border: 1px #ddd solid;
        font-size: 12px;
        vertical-align: top;
      }

      th {
        text-align: center;
      }
    }
  }

  .sellerListPopup {
    padding: 30px 0 0;
    text-align: center;
    border-radius: 5px;

    .wrap {
      padding: 0 20px;

      .content {
        margin-top: 12px;
      }

      .listWrap {
        margin-top: 20px;
        height: 263px;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        border: solid 1px #f1f1f1;

        .list {
          padding: 16px 16px 0;
          text-align: left;

          ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;

            li {
              flex-basis: calc(100% / 3);
              padding-right: 3%;
              margin-bottom: 10px;
            }
          }
        }
      }
    }

    button {
      width: 100%;
      padding: 17px 0;
      color: #333;
      font-size: 17px;
      line-height: 1;
      border-top: solid 1px #f1f1f1;
    }
  }

  .adTerm {
    font-size: 12px;
    color: rgb(0, 82, 204);
    text-decoration: underline;
  }

  .bullet {
    line-height: 20px;
    vertical-align: middle;
    position: absolute;
    top: 0;
    left: -15px;
  }

  //all
  .termsCont {
    .termsTable {
      width: 100%;
      border: 1px #ddd solid;
      border-collapse: collapse;

      td,
      th {
        padding: 5px;
        border: 1px #ddd solid;
        font-size: 12px;
        vertical-align: top;
      }

      th {
        text-align: center;
      }

      .w20 {
        width: 20%;
      }
      .w25 {
        width: 25%;
      }
      .w30 {
        width: 30%;
      }
      .w40 {
        width: 40%;
      }
      .w70 {
        width: 70%;
      }
    }

    ul {
      padding-left: 15px;

      li {
        position: relative;
        line-height: 20px;
        vertical-align: middle;
      }
    }
  }

  .adTerm {
    font-size: 12px;
    color: rgb(0, 82, 204);
    text-decoration: underline;
  }

  .bullet {
    line-height: 20px;
    vertical-align: middle;
    position: absolute;
    top: 0;
    left: -15px;
  }

  .menu {
    .content {
      overflow: hidden;
      background-color: rgba(255, 255, 255, 1);

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        border-bottom: 1px solid #f1f1f1;

        & > p {
          font-size: 17px;
          font-weight: bold;
        }

        & > button {
          width: 40px;
          height: 40px;
          background-size: 400px auto;
          background-repeat: no-repeat;
          background-image: url('../../asset/img/icon/sprite_header.png');
          z-index: 1;
          position: relative;
          background-position: -80px 0;
        }
      }
      .btnList {
        max-height: 200px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      .contentBtn {
        display: block;
        width: 100%;
        color: #979797;

        &.select {
          color: #333333;
          font-weight: bold;
        }
      }
    }
  }

  .effectiveDate {
    font-size: 14px;
    color: #979797;
  }

  .selectEffectiveDate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px;
    width: 100%;
    border: 1px solid #c5c5c5;
    font-size: 14px;
    color: #979797;
  }
`;

export const PopUp = (showPopup: boolean) => css`
  display: ${showPopup ? 'abscolute' : ' none'};
  left: 0;
  top: 0;
  z-index: 500;
  background-color: rgba(0, 0, 0, 0.5);
`;
